import { render, staticRenderFns } from "./DashboardOptions.vue?vue&type=template&id=44e72ddb&scoped=true&"
import script from "./DashboardOptions.vue?vue&type=script&lang=js&"
export * from "./DashboardOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e72ddb",
  null
  
)

export default component.exports